import React from 'react';
import { connect } from 'react-redux';

import OperationalDashboard from '../index';
import OperationalDashboardCard from '../components/OperationalDashboardCard';
import './styles.css';
import TwoLinesContent from '../components/CardContentTypes/TwoLinesContent';
import Table from '../components/Table';
import { getWarehouseData } from '../../../redux/operational-dashboard-warehouse';

import LoadMask from '../../../components/LoadMask';

class Wharehouse extends React.Component {
  componentDidMount() {
    this.props.getWarehouseData();
    this.interval = setInterval(() => {
      this.props.getWarehouseData();
    }, 300000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      data,
      isFetching,
    } = this.props;

    if (isFetching) {
      return <LoadMask text="Carregando" />;
    }
    return (
      <OperationalDashboard>
        {data &&
          <div className="container-fluid OperationalDashboard OperationalDashboard-flex">
            <div className="row padding OperationalDashboard-flex">
              <div className="col-md-6">
                <div className="row OperationalDashboard-flex OperationalDashboard-height">
                  <OperationalDashboardCard
                    heightAuto
                    title="Em separação (vendas)"
                  >
                    {data.inSeparation && (
                      <TwoLinesContent
                        firstSlotData={{
                          label: 'Toneladas em separação',
                          value: `${data.inSeparation.tons} ton`,
                        }}
                        secondSlotData={{
                          label: 'NFs emitidas',
                          value: data.inSeparation.invoicesIssued,
                        }}
                      />
                    )}
                  </OperationalDashboardCard>
                  {data.separated && (
                    <OperationalDashboardCard
                      title="Separadas (vendas)"
                      heightAuto
                    >
                      <TwoLinesContent
                        firstSlotData={{
                          label: 'Toneladas separadas',
                          value: `${data.separated.tons} ton`,
                        }}
                        secondSlotData={{
                          label: 'NFs emitidas',
                          value: data.separated.invoicesIssued,
                        }}
                      />
                    </OperationalDashboardCard>
                  )}
                  {data.onReception && (
                    <OperationalDashboardCard
                      title="Em recebimento"
                      heightAuto
                    >
                      <TwoLinesContent
                        theme="success"
                        firstSlotData={{
                          label: 'Toneladas em estoque',
                          value: `${data.onReception.tons} ton`,
                        }}
                        secondSlotData={{
                          label: 'NFs emitidas',
                          value: data.onReception.invoicesIssued,
                        }}
                      />
                    </OperationalDashboardCard>
                  )}
                  {data.received && (
                    <OperationalDashboardCard
                      title="Recebidas"
                      heightAuto
                    >
                      <TwoLinesContent
                        theme="success"
                        firstSlotData={{
                          label: 'Toneladas recebidas',
                          value: `${data.received.tons} ton`,
                        }}
                        secondSlotData={{
                          label: 'NFs emitidas',
                          value: data.received.invoicesIssued,
                        }}
                      />
                    </OperationalDashboardCard>
                  )}
                </div>
              </div>
              {data.byState && (
                <OperationalDashboardCard
                  title="Por estado (vendas)"
                >
                  <Table
                    header={[
                      'Estado',
                      'Em separação',
                      'Separado',
                    ]}
                    states={data.byState.filter((state, key) => key < 12)}
                    total={data.allBrazil}
                  />
                </OperationalDashboardCard>
              )}
            </div>
          </div>
        }
      </OperationalDashboard>
    );
  }
}

const mapStateToProps = state => ({
  data: state.operationalDashboardWarehouse.data,
  isFetching: state.operationalDashboardWarehouse.isFetching,
});

const mapActionsToProps = {
  getWarehouseData,
};

export default connect(mapStateToProps, mapActionsToProps)(Wharehouse);
